export default __webpack_public_path__ + "static/media/rounds.bfd14ba7.svg";